/** Common column types used by ag-grid in Helios. */
import { ColDef } from '@ag-grid-community/core'
import { NfColumnTypes, NfGridOptions } from '@northfork/ag-grid'
import {
  AngularColumnTypeEnum,
  NfColumnTypeDefs,
  RowActionsColumn,
} from '@northfork/ag-grid-angular'
import { HsBooleanColDef } from './boolean'
import { HsBreakStatusColDef } from './break-status'
import { HsBulkIsEditedColDef } from './bulk-is-edited'
import { HsDateColDef } from './date'
import {
  HsCurrentTimeZoneDateColDef,
  HsDateTimeColDef,
  HsShortDateTimeColDef,
} from './datetime'
import { HsHPLNumberColDef } from './hpl-number'
import { HsMilRateColDef } from './mil-rate'
import { HsPreciseNumberColDef } from './precise-number'
import { HsTimeColDef } from './time'

export enum HeliosColumnTypes {
  /** Ag-grid column type that formats date-time objects to simple timestamps. */
  Time = 'Time',
  /** Ag-grid column type that displays boolean values as icons. */
  Boolean = 'Boolean',
  /** Ag-grid column type that display date-time objects as date time strings. */
  DateTime = 'DateTime',
  /** Formats number objects to five decimal places  */
  PreciseNumber = 'PreciseNumber',
  /** Formats number objects to 4 decimal places  */
  HPLNumber = 'HPLNumber',
  /** Formats break status enum to icons */
  BreakStatus = 'BreakStatus',
  /** Formats number objects to eight decimal places  */
  MilRate = 'MilRate',
  /** Boolean column for bulk panels that indicates whether the row has been edited by the user or not */
  BulkIsEdited = 'BulkIsEdited',
  /** Formats Short DateTime in mm/dd/yy hh:mm:ss */
  ShortDateTime = 'ShortDateTime',
  /** Formats and Converts DateTime in mm/dd/yy hh:mm:ss to current timezone */
  CurrentTimeZoneDate = 'CurrentTimeZoneDate',
}

/** Default column type definitions commonly used by Helios. */
export const heliosColumnTypes: Record<
  HeliosColumnTypes | NfColumnTypes | AngularColumnTypeEnum | string,
  ColDef
> = {
  [AngularColumnTypeEnum.RowAction]: RowActionsColumn,
  ...NfGridOptions.columnTypes,
  ...NfColumnTypeDefs,
  [HeliosColumnTypes.Boolean]: HsBooleanColDef,
  [HeliosColumnTypes.Time]: HsTimeColDef,
  [HeliosColumnTypes.DateTime]: HsDateTimeColDef,
  [NfColumnTypes.Date]: HsDateColDef,
  [HeliosColumnTypes.PreciseNumber]: HsPreciseNumberColDef,
  [HeliosColumnTypes.HPLNumber]: HsHPLNumberColDef,
  [HeliosColumnTypes.BreakStatus]: HsBreakStatusColDef,
  [HeliosColumnTypes.MilRate]: HsMilRateColDef,
  [HeliosColumnTypes.BulkIsEdited]: HsBulkIsEditedColDef,
  [HeliosColumnTypes.ShortDateTime]: HsShortDateTimeColDef,
  [HeliosColumnTypes.CurrentTimeZoneDate]: HsCurrentTimeZoneDateColDef,
}
